@if (currentBanner?.bannerImg) {
<div class="ratio-7-1 ratio-2-1-m ratio-2-1-s"
     [class.p-b-4-s]="position === 'top'">
    <href [link]="redirectLink"
          [hrefTarget]="urlTarget"
          (click)="trackClick()">
        <img [dfImage]="currentBanner.bannerImg"
             [ratio]="client.isS || client.isM ? '2/1' : '7/1'"
             fill>
    </href>
</div>
}